<template>
<svg v-b-tooltip.hover.top="'Edit campaign'" width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.136719" y="0.626953" width="23.04" height="23.04" rx="11.52" fill="#F4F4F4"/>
<path d="M6.63477 15.0869V17.1869H8.75803L15.0203 10.9933L12.897 8.89327L6.63477 15.0869ZM16.6623 9.36927C16.8831 9.15087 16.8831 8.79807 16.6623 8.57967L15.3373 7.26927C15.1165 7.05087 14.7598 7.05087 14.539 7.26927L13.5028 8.29407L15.6261 10.3941L16.6623 9.36927Z" fill="#B8CDD7"/>
</svg>


</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
    svg {
        cursor: pointer;
        rect, path {
            transition: all 0.2s ease;
        }
        &:hover {
            rect {
                fill: #B8CDD7;
            }
            path {
                fill: #F4F4F4;
            }
        }
    }
</style>